import axios, { AxiosRequestConfig, isAxiosError } from 'axios';
import { store } from '../redux/store';
import AuthActions from '../redux/auth/action';
import { toast } from 'react-toastify';

export interface IResData<T> {
  success: boolean;
  status: number;
  message?: string | null;
  data: T;
}

export interface IPaginationQuery {
  page?: number;
  limit?: number;
}

export interface IPaginationData<T> {
  total: number;
  total_page: number;
  page: number;
  limit: number;
  records: Array<T>;
}

export async function request<T>(options: AxiosRequestConfig) {
  return axios
    .request<IResData<T>>({
      baseURL: process.env.REACT_APP_API_URI,
      ...options,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        ...options.headers,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      if (isAxiosError(err)) {
        if (err.response?.status === 401) {
          store.dispatch(AuthActions.setAuth(false));
          store.dispatch(AuthActions.setUser(undefined));
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          toast.error('Session is expired');
          throw err;
        }
      }

      toast.error(err.response?.message || err.message || err.toString());

      throw err;
    });
}
